import { apiFetch } from "../client.js";
import { state, patch } from "../../state/store.js";

export async function fetchTags() {
  const data = await apiFetch("/whatsapp/tags");
  patch({ chatTags: data?.tags || [] });
  return data?.tags || [];
}

export async function createTag({ name, color = "#108b7c" }) {
  const tag = await apiFetch("/whatsapp/tags", {
    method: "POST",
    body: JSON.stringify({ name, color }),
  });
  patch({ chatTags: [...(state.chatTags || []), tag] });
  return tag;
}

export async function updateTag(id, { name, color }) {
  const tag = await apiFetch(`/whatsapp/tags/${id}`, {
    method: "PATCH",
    body: JSON.stringify({ name, color }),
  });
  patch({
    chatTags: (state.chatTags || []).map((item) => (item.id === id ? tag : item)),
  });
  return tag;
}

export async function deleteTag(id) {
  await apiFetch(`/whatsapp/tags/${id}`, { method: "DELETE" });
  patch({ chatTags: (state.chatTags || []).filter((item) => item.id !== id) });
}

export async function attachTagToChat(chatJid, tagId) {
  await apiFetch(`/whatsapp/chats/${encodeURIComponent(chatJid)}/tags/${tagId}`, { method: "POST" });
  applyTagPatch(chatJid, { added: tagId });
}

export async function detachTagFromChat(chatJid, tagId) {
  await apiFetch(`/whatsapp/chats/${encodeURIComponent(chatJid)}/tags/${tagId}`, { method: "DELETE" });
  applyTagPatch(chatJid, { removed: tagId });
}

function applyTagPatch(chatJid, { added, removed }) {
  const idx = state.chats.findIndex((chat) => chat.chatJid === chatJid);
  if (idx < 0) return;
  const next = [...state.chats];
  const tagIds = new Set(next[idx].tagIds || []);
  if (added) tagIds.add(added);
  if (removed) tagIds.delete(removed);
  next[idx] = { ...next[idx], tagIds: Array.from(tagIds) };
  patch({ chats: next });
}
